"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _SearcherDateCarousel = _interopRequireDefault(require("../SearcherDateCarousel"));
var _excluded = ["className", "children", "showSkeleton"];
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var BADGE_WIDTH = 106;
var ACTIVE_BACKGROUND_TRIANGLE_HEIGHT = 13;
var WHITE_TRIANGLE_HEIGHT = 15;
var itemStyle = {
  width: BADGE_WIDTH
};
var SearcherDateCarouselMobile = /*#__PURE__*/function (_React$PureComponent) {
  function SearcherDateCarouselMobile(props) {
    var _this;
    (0, _classCallCheck2["default"])(this, SearcherDateCarouselMobile);
    _this = _callSuper(this, SearcherDateCarouselMobile, [props]);
    _this.state = {
      swiper: null
    };
    _this.handleItemClick = _this.handleItemClick.bind(_this);
    _this.updateSwiper = _this.updateSwiper.bind(_this);
    _this.handleSlideChange = _this.handleSlideChange.bind(_this);
    return _this;
  }
  (0, _inherits2["default"])(SearcherDateCarouselMobile, _React$PureComponent);
  return (0, _createClass2["default"])(SearcherDateCarouselMobile, [{
    key: "handleItemClick",
    value: function handleItemClick(_ref) {
      var currentTarget = _ref.currentTarget;
      var index = currentTarget.dataset.index;
      var swiper = this.state.swiper;
      if (!swiper) {
        return;
      }
      swiper.slideTo(index);
    }
  }, {
    key: "handleSlideChange",
    value: function handleSlideChange(activeIndex) {
      var _this2 = this;
      var swiper = this.state.swiper;
      var children = this.props.children;
      if (!swiper) {
        return;
      }
      if (SearcherDateCarouselMobile.isItemDisabled(children[activeIndex])) {
        var directionFn = activeIndex > swiper.previousIndex ? 'slideNext' : 'slidePrev';
        swiper[directionFn]();
      }

      // swiper внутри себя устанавливает активный элемент,
      // но элементы карусели не перерендериваются в этом компоненте
      // для этого вызываем forceUpdate
      this.forceUpdate(function () {
        var onChange = _this2.props.onChange;
        var forceIndex = swiper.activeIndex;
        var dateValue = children[forceIndex].props.dateValue;
        onChange(dateValue);
      });
    }
  }, {
    key: "updateSwiper",
    value: function updateSwiper(swiper) {
      var getSwiper = this.props.getSwiper;
      this.setState({
        swiper: swiper
      });
      getSwiper(swiper);
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;
      var swiper = this.state.swiper;
      var _this$props = this.props,
        className = _this$props.className,
        children = _this$props.children,
        showSkeleton = _this$props.showSkeleton,
        props = (0, _objectWithoutProperties2["default"])(_this$props, _excluded);
      var handleSlideChange = this.handleSlideChange;
      return /*#__PURE__*/_react["default"].createElement(StyledContainer, {
        className: className
      }, /*#__PURE__*/_react["default"].createElement(StyledSearcherDateCarousel, (0, _extends2["default"])({}, props, {
        noSwiping: showSkeleton,
        runCallbacksOnInit: false,
        on: {
          slideChange: function slideChange() {
            handleSlideChange(this.activeIndex);
          }
        },
        getSwiper: this.updateSwiper
      }), _react["default"].Children.map(children, function (child, index) {
        var active = index === (swiper && swiper.activeIndex);
        var newProps = {
          active: active,
          mobile: true,
          'data-index': index,
          style: itemStyle,
          skeleton: showSkeleton
        };
        if (!active) {
          newProps.onClick = _this3.handleItemClick;
        }
        return /*#__PURE__*/_react["default"].cloneElement(child, newProps);
      })), /*#__PURE__*/_react["default"].createElement(StyledBadge, null, /*#__PURE__*/_react["default"].createElement(StyledYellowTriangle, null), /*#__PURE__*/_react["default"].createElement(StyledWhiteTriangle, null)));
    }
  }], [{
    key: "isItemDisabled",
    value: function isItemDisabled(item) {
      var _item$props = item.props,
        price = _item$props.price,
        priceOnDemand = _item$props.priceOnDemand;
      return !price && !priceOnDemand;
    }
  }]);
}(_react["default"].PureComponent);
SearcherDateCarouselMobile.propTypes = {
  className: _propTypes["default"].string,
  children: _propTypes["default"].node.isRequired,
  initialSlide: _propTypes["default"].number.isRequired,
  onChange: _propTypes["default"].func,
  showSkeleton: _propTypes["default"].bool,
  getSwiper: _propTypes["default"].func
};
SearcherDateCarouselMobile.defaultProps = {
  className: '',
  onChange: Function.prototype,
  showSkeleton: false,
  getSwiper: Function.prototype
};
var StyledContainer = _styledComponents["default"].div.withConfig({
  displayName: "SearcherDateCarouselMobile__StyledContainer",
  componentId: "sc-1vkx9gx-0"
})(["position:relative;margin-bottom:20px;background:var(--white);border-radius:0 0 var(--border-radius) var(--border-radius);::before,::after{content:'';display:block;position:absolute;top:0;left:0;width:30px;height:100%;z-index:2;background-image:linear-gradient(to left,rgba(255,255,255,0),rgb(255,255,255));border-radius:var(--border-radius) 0 0 var(--border-radius);}::after{left:auto;right:0;transform:rotate(180deg);}"]);
var StyledSearcherDateCarousel = (0, _styledComponents["default"])(_SearcherDateCarousel["default"]).withConfig({
  displayName: "SearcherDateCarouselMobile__StyledSearcherDateCarousel",
  componentId: "sc-1vkx9gx-1"
})(["height:77px;padding-top:5px;position:relative;z-index:1;background:none;border-radius:0;"]);
var StyledBadge = _styledComponents["default"].div.withConfig({
  displayName: "SearcherDateCarouselMobile__StyledBadge",
  componentId: "sc-1vkx9gx-2"
})(["width:", "px;position:absolute;z-index:0;left:50%;top:0;transform:translateX(-50%);padding-top:72px;::before{content:'';position:absolute;left:0;top:5px;right:0;bottom:", "px;z-index:0;background:var(--background);border-radius:var(--border-radius);}"], BADGE_WIDTH, ACTIVE_BACKGROUND_TRIANGLE_HEIGHT + WHITE_TRIANGLE_HEIGHT);
var StyledTriangle = _styledComponents["default"].i.withConfig({
  displayName: "SearcherDateCarouselMobile__StyledTriangle",
  componentId: "sc-1vkx9gx-3"
})(["position:relative;width:0;height:0;z-index:1;display:block;"]);
var ACTIVE_BACKGROUND_TRIANGLE_OFFSET = 10;
var StyledYellowTriangle = (0, _styledComponents["default"])(StyledTriangle).withConfig({
  displayName: "SearcherDateCarouselMobile__StyledYellowTriangle",
  componentId: "sc-1vkx9gx-4"
})(["left:", "px;border-top:", "px solid var(--background);border-left:", "px solid transparent;border-right:", "px solid transparent;z-index:2;"], ACTIVE_BACKGROUND_TRIANGLE_OFFSET / 2, ACTIVE_BACKGROUND_TRIANGLE_HEIGHT, (BADGE_WIDTH - ACTIVE_BACKGROUND_TRIANGLE_OFFSET) / 2, (BADGE_WIDTH - ACTIVE_BACKGROUND_TRIANGLE_OFFSET) / 2);
var StyledWhiteTriangle = (0, _styledComponents["default"])(StyledTriangle).withConfig({
  displayName: "SearcherDateCarouselMobile__StyledWhiteTriangle",
  componentId: "sc-1vkx9gx-5"
})(["bottom:8px;left:0;border-top:", "px solid var(--white);border-left:", "px solid transparent;border-right:", "px solid transparent;"], WHITE_TRIANGLE_HEIGHT, BADGE_WIDTH / 2, BADGE_WIDTH / 2);
var _default = exports["default"] = SearcherDateCarouselMobile;